import { formatPrice, type Locale } from '@geoic/shared';

/** Interfeys tili — hozircha faqat o'zbekcha (TZ 4.1). */
export const UI_LOCALE: Locale = 'uz';

/** `42 721 875 so'm` yoki narx yo'q bo'lsa «Narxni so'rang» (ADR-004). */
export function price(value: number | null | undefined): string {
  return formatPrice(value ?? null, UI_LOCALE) ?? 'Narxni so‘rang';
}

/**
 * `06.08.2026 14:32` — admin jadvallaridagi yagona format (D2).
 *
 * `Intl.DateTimeFormat('uz-UZ')` ishlatilmaydi: brauzerlarda o'zbek lokali
 * to'liq emas va ba'zilari `2026-08-06` ko'rinishida qaytaradi. Jadvalda
 * sana formati qurilmaga qarab o'zgarib turishi mumkin emas.
 */
export function dateTime(value: string | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';

  return `${dateOnly(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function dateOnly(value: string | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';

  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/** `1,4 MB` — media kutubxonada fayl hajmi. */
export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
